import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {ELearningListComponent} from './e-learning-list/e-learning-list.component';
import {ELearningReportComponent} from './e-learning-report/e-learning-report.component';

const routes: Routes = [
    {
        path: '',
        component: ELearningListComponent
    },
    {
        path: 'report/:eDelegateId',
        component: ELearningReportComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class ELearningPageRoutingModule {
}
